/**
 * @author: Pawan Singh Sisodiya
 */
import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import schoolApi from "../../api/schoolApi";
import { useReactToPrint } from "react-to-print";
import { Helmet } from "react-helmet";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InstallmentTable from "./InstallmentTable";
import FeeReceipt from "./FeeReceipt";
import moment from "moment";
import html2pdf from "html2pdf.js";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
const parseSafe = (val) => {
  if (typeof val === "string") return parseInt(val.replace(/,/g, "")) || 0;
  return parseInt(val) || 0;
};
function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
const FeeDepositeEdit = (props) => {
  const getCurrentDate = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };

  const formatDateForPayload = (date) => {
    if (!date) {
      return "";
    }
    if (moment.isMoment(date)) {
      return date.format("YYYY-MM-DD");
    }
    if (date instanceof Date) {
      if (isNaN(date.getTime())) return "";
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${year}-${month}-${day}`;
    }
    if (typeof date === "string") {
      if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
        return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
      return moment(date).format("YYYY-MM-DD");
    }
    return moment(date).format("YYYY-MM-DD");
  };

  const calculateInstallmentLateFee = (
    installment,
    paymentDate,
    frequencySettings,
    lateFeeSettings,
    isRte
  ) => {
    if (installment?.status === "completed" || isRte) {
      return parseSafe(installment?.pushed_late_fee || installment?.late_fee || 0);
    }

    const referenceMoment = paymentDate
      ? moment(paymentDate, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601])
      : moment();
    referenceMoment.startOf("day");

    const dueMoment = installment?.due_date
      ? moment(installment.due_date, ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601])
      : null;

    if (!dueMoment || !dueMoment.isValid()) {
      return parseSafe(installment?.late_fee || 0);
    }

    dueMoment.startOf("day");

    if (dueMoment.isSameOrAfter(referenceMoment)) {
      return 0;
    }

    const frequency = parseInt(frequencySettings, 10) || 1;
    const lateFee = parseInt(lateFeeSettings, 10) || 0;
    if (lateFee <= 0) {
      return parseSafe(installment?.late_fee || 0);
    }

    const differenceInDays = referenceMoment.diff(dueMoment, "days");
    const netDueDays = Math.floor((differenceInDays + frequency) / frequency);

    return Math.round(netDueDays * lateFee);
  };

  const normalizeInstallmentsForPaymentDate = (
    installments,
    paymentDate,
    frequencySettings,
    lateFeeSettings
  ) => {
    if (!Array.isArray(installments)) {
      return [];
    }

    const normalizedInstallments = installments.map((item) => ({
      ...item,
      late_fee_paid: parseSafe(item.late_fee_paid || 0), // Preserve DB value (paid so far)
      late_fee: Math.max(
        parseSafe(item.late_fee || 0),
        calculateInstallmentLateFee(
          item,
          paymentDate,
          frequencySettings,
          lateFeeSettings,
          studentRecord?.isrte
        )
      ),
    }));

    return normalizedInstallments.map((item) => {
      if (item.deposit_id && item.late_fee > 0) {
        const itemDepositIds = Array.isArray(item.deposit_id)
          ? item.deposit_id.map((id) => String(id).trim())
          : String(item.deposit_id).split(",").map((id) => id.trim());
        const lateFeeHelper = normalizedInstallments.filter(
          (ft) => {
            const feeDepositIds = Array.isArray(ft.deposit_id)
              ? ft.deposit_id.map((id) => String(id).trim())
              : String(ft.deposit_id || "").split(",").map((id) => id.trim());
            return feeDepositIds.some((id) => itemDepositIds.includes(id));
          }
        );

        if (item.id !== lateFeeHelper[lateFeeHelper.length - 1]?.id) {
          return { ...item, late_fee: 0, late_fee_paid: 0 };
        }
      }

      return item;
    });
  };

  const [selectedReceiptData, setSelectedReceiptData] = useState(null);
  const [isReceiptReady, setIsReceiptReady] = useState(false);
  const receiptRef = useRef();
  const location = useLocation();
  const [readOnly, setReadOnly] = useState(location?.state?.readonly ? location?.state?.readonly : false);
  const [studentRecord, SetStudentRecord] = useState(
    location?.state?.row?.student_info ? location?.state?.row?.student_info : {}
  );
  const [studentInstallment, setStudentInstallment] = useState();
  const [baseInstallments, setBaseInstallments] = useState([]);
  const [lateFeeConfig, setLateFeeConfig] = useState({
    frequencySettings: 0,
    lateFeeSettings: 0,
  });
  const [feeDeposit, setFeeDeposit] = useState({});
  const [disablebutton, setdisablebutton] = useState(false);
  const [tempAmount, setTempAmount] = useState({});
  const [showTransaction, setShowTransaction] = useState(true);
  const [isDiscountEditable, setIsDiscountEditable] = useState(false);
  const [receiptNumberMode, setReceiptNumberMode] = useState("auto");
  let [reportData, setReportData] = useState({ payment_date: getCurrentDate() });
  const navigate = useNavigate();
  const handleDateChange = (date, name) => {
    const selectedDate = date ? new Date(date) : null;
    if (selectedDate) {
      selectedDate.setHours(0, 0, 0, 0);
    }

    if (date) {
      setReportData((prevState) => ({
        ...prevState,
        [name]: selectedDate,
      }));
      setFeeDeposit((prev) => {
        return { ...prev, [name]: formatDateForPayload(selectedDate) };
      });
    } else {
      setReportData((prevState) => ({
        ...prevState,
        [name]: "",
      }));
      setFeeDeposit((prev) => {
        return { ...prev, [name]: "" };
      });
    }
  };

  useEffect(() => {
    const rowData = location?.state?.row;
    if (rowData) {
      const studentData = rowData.student_info || rowData;


      if (studentData.studentname) {
        SetStudentRecord(studentData);
        sessionStorage.setItem(
          "temp",
          JSON.stringify(rowData.student_info || rowData)
        );
      } else {
        const tempData = JSON.parse(sessionStorage.getItem("temp"));
        if (tempData) {
          SetStudentRecord(tempData);
        }
      }
    }
  }, [location.state.row]);
  useEffect(() => {
    initClass();
  }, [studentRecord]);

  useEffect(() => {
    if (!baseInstallments.length) {
      return;
    }

    const freq = parseSafe(lateFeeConfig.frequencySettings);
    const lateRate = parseSafe(lateFeeConfig.lateFeeSettings);

    // If late fee settings have not loaded yet from backend, do not overwrite baseInstallments with 0
    if (freq <= 0 && lateRate <= 0) {
      if (!studentInstallment || studentInstallment.length === 0) {
        setStudentInstallment(baseInstallments);
      }
      return;
    }

    let normalizedInstallments = normalizeInstallmentsForPaymentDate(
      baseInstallments,
      reportData.payment_date,
      freq,
      lateRate
    );

    if (studentInstallment && studentInstallment.length > 0) {
      normalizedInstallments = normalizedInstallments.map(item => {
        const existing = studentInstallment.find(si => si.id === item.id);
        return {
          ...item,
          isCheked: existing ? existing.isCheked : item.isCheked
        };
      });
    }

    if (studentRecord?.edit) {
      const editableInstallments = normalizedInstallments.map((res) => {
        const isMatched = Array.isArray(res.deposit_id)
          ? res.deposit_id.includes(studentRecord.deposit_id)
          : res.deposit_id === studentRecord.deposit_id;

        if (isMatched) {
          return { ...res, edit: true };
        }

        return { ...res, edit: false };
      });

      setStudentInstallment(editableInstallments);
      feeDepositHandler(
        editableInstallments.filter((item) => item.edit && item.status === "completed")
      );
      return;
    }

    setStudentInstallment(normalizedInstallments);
    const checkedInstallments = normalizedInstallments.filter((item) => item.isCheked);
    if (checkedInstallments.length) {
      feeDepositHandler(checkedInstallments);
    }
  }, [
    baseInstallments,
    reportData.payment_date,
    studentRecord?.deposit_id,
    lateFeeConfig.frequencySettings,
    lateFeeConfig.lateFeeSettings,
  ]);


  async function initClass() {
    try {
      setdisablebutton(false);

      let frequencySettings = 0;
      let lateFeeSettings = 0;
      let receiptMode = "auto";
      const ResultSettings = await schoolApi.getAllSetting();
      if (ResultSettings.success) {
        frequencySettings = ResultSettings?.data?.find(
          (res) => res.key === "frequency"
        )?.value || 0;
        lateFeeSettings = ResultSettings?.data?.find(
          (res) => res.key === "late_fee"
        )?.value || 0;
        const modeVal = ResultSettings?.data?.find(
          (res) => res.key === "receipt_number_mode"
        )?.value;
        if (modeVal) {
          receiptMode = modeVal.toLowerCase();
        }
      }
      setReceiptNumberMode(receiptMode);
      const insResult = await schoolApi.getallIntsallment(
        studentRecord?.student_addmission_id,
        studentRecord?.session_id
          ? studentRecord?.session_id
          : studentRecord?.sessionid,
        readOnly ? studentRecord?.fee_master_installment_id : undefined
      );

      let sessionDiscountsMap = {};
      try {
        const sessionId = studentRecord?.session_id || studentRecord?.sessionid;
        if (sessionId) {
          const dResult = await schoolApi.fetchFeeDiscounts(sessionId);
          if (dResult?.result && Array.isArray(dResult.result)) {
            dResult.result.forEach(r => {
               if (r.discount) {
                 sessionDiscountsMap[String(r.discount.id)] = r.discount;
               }
            });
          }
        }
      } catch (e) {
        console.error("Error fetching discounts", e);
      }

      if (insResult?.result && Array.isArray(insResult.result)) {
        const sessionMonthOrder = [
          "august", "september", "october", "november", "december",
          "january", "february", "march", "april", "may", "june", "july"
        ];
        insResult.result.sort((a, b) => {
          const aMonth = (a.month || "").split(/ to | /)[0].toLowerCase().trim();
          const bMonth = (b.month || "").split(/ to | /)[0].toLowerCase().trim();
          const aIdx = sessionMonthOrder.indexOf(aMonth);
          const bIdx = sessionMonthOrder.indexOf(bMonth);
          if (aIdx !== -1 && bIdx !== -1) return aIdx - bIdx;
          const aDate = a.due_date ? new Date(a.due_date).getTime() : 0;
          const bDate = b.due_date ? new Date(b.due_date).getTime() : 0;
          return aDate - bDate;
        });

        insResult.result = insResult.result.map(inst => {
          const depositedTuition = parseFloat(inst.deposited_amount || inst.deposit_amount || 0);
          const totalInstBase = (parseFloat(inst.installment_amount) || 0) + (parseFloat(inst.transport_fee) || 0);
          const isPaid =
            inst.status === "completed" ||
            depositedTuition > 0 ||
            (inst.deposit_id &&
              (Array.isArray(inst.deposit_id)
                ? inst.deposit_id.length > 0
                : String(inst.deposit_id).trim() !== ""));

          if (isPaid) {
            const instAmount = parseFloat(inst.installment_amount) || 0;
            if (inst.heads && Array.isArray(inst.heads) && instAmount > 0) {
              let runningTotal = 0;
              inst.heads = inst.heads.filter(h => {
                const hAmt = parseFloat(h.head_amount || h.amount || 0);
                if (hAmt <= 0) return true;
                if (runningTotal + hAmt <= instAmount) {
                  runningTotal += hAmt;
                  return true;
                }
                return false;
              });
            }

            if (depositedTuition >= totalInstBase) {
              inst.installment_discount = 0;
            } else if (depositedTuition > 0) {
              inst.installment_discount = Math.min(
                parseFloat(inst.installment_discount || 0),
                Math.max(0, totalInstBase - depositedTuition)
              );
            }
            return inst;
          }

          if (inst.discounts && Array.isArray(inst.discounts) && inst.discounts.length > 0) {
            let totalInstDiscount = 0;
            inst.discounts.forEach(d => {
              const fullDiscount = sessionDiscountsMap[String(d.id)] || d;
              if (fullDiscount) {
                let feeHeadIds = fullDiscount.fee_head_id;
                if (typeof feeHeadIds === 'string') {
                  try {
                    feeHeadIds = JSON.parse(feeHeadIds);
                  } catch (e) {
                    if (feeHeadIds.startsWith("{") && feeHeadIds.endsWith("}")) {
                      feeHeadIds = feeHeadIds.slice(1, -1).split(",").map(s => s.trim());
                    } else {
                      feeHeadIds = [feeHeadIds.trim()];
                    }
                  }
                }
                if (!Array.isArray(feeHeadIds)) {
                  feeHeadIds = feeHeadIds ? [feeHeadIds] : [];
                }
                feeHeadIds = feeHeadIds
                  .map(id => (typeof id === "object" && id !== null ? (id.fee_head_id || id.id || id.value) : id))
                  .filter(id => {
                    const s = String(id || "").trim();
                    return s !== "" && s !== "null" && s !== "{}" && s !== "undefined";
                  });

                const discountAmount = parseFloat(fullDiscount.amount) || 0;
                const discountPercent = parseFloat(fullDiscount.percent) || 0;
                const hasSpecificHeads = feeHeadIds.length > 0;

                if (hasSpecificHeads) {
                  const matchingHeads = (inst.heads || []).filter(h =>
                    feeHeadIds.some(fid => String(fid) === String(h.fee_head_master_id || h.id))
                  );
                  if (matchingHeads.length > 0) {
                    const matchedAmount = matchingHeads.reduce(
                      (sum, h) => sum + (parseFloat(h.head_amount || h.amount || 0) || 0),
                      0
                    );
                    if (matchedAmount > 0) {
                      if (discountAmount > 0) {
                        totalInstDiscount += Math.min(discountAmount, matchedAmount);
                      } else if (discountPercent > 0) {
                        totalInstDiscount += Math.round((matchedAmount * discountPercent) / 100);
                      }
                    }
                  }
                } else {
                  const totalHeadsAmount = (inst.heads || []).reduce(
                    (sum, h) => sum + (parseFloat(h.head_amount || h.amount || 0) || 0),
                    0
                  );
                  const baseAmount = totalHeadsAmount > 0 ? totalHeadsAmount : (parseFloat(inst.installment_amount) || 0);
                  if (baseAmount > 0) {
                    if (discountAmount > 0) {
                      totalInstDiscount += Math.min(discountAmount, baseAmount);
                    } else if (discountPercent > 0) {
                      totalInstDiscount += Math.round((baseAmount * discountPercent) / 100);
                    }
                  }
                }
              }
            });

            const maxAllowed = parseFloat(inst.installment_amount) || totalInstDiscount;
            inst.installment_discount = Math.min(maxAllowed, totalInstDiscount);
          }
          return inst;
        });
      }

      let currentDeposit = null;
      if (studentRecord?.edit && studentRecord?.deposit_id) {
        const depositResult = await schoolApi.fetchFeeDepositsByStudentId(
          studentRecord.student_addmission_id,
          studentRecord.session_id || studentRecord.sessionid,
          studentRecord.deposit_id
        );
        currentDeposit = depositResult?.result?.[0] || depositResult?.[0] || null;
      }

      const paymentDateForCalculation = studentRecord?.payment_date
        ? moment(studentRecord.payment_date, "DD-MM-YYYY").toDate()
        : reportData.payment_date || getCurrentDate();

      let normalizedInstallments = normalizeInstallmentsForPaymentDate(
        insResult?.result || [],
        paymentDateForCalculation,
        frequencySettings,
        lateFeeSettings
      );

      if (studentRecord?.edit && studentRecord?.deposit_id) {
        const matchingIndexes = normalizedInstallments
          .map((item, index) => {
            const depositIds = Array.isArray(item.deposit_id)
              ? item.deposit_id.map((id) => String(id))
              : String(item.deposit_id || "").split(",");
            const receiptDepositIds = Array.isArray(studentRecord.deposit_id)
              ? studentRecord.deposit_id.map((id) => String(id))
              : String(studentRecord.deposit_id).split(",");
            return depositIds.some((id) => receiptDepositIds.includes(id.trim())) ? index : -1;
          })
          .filter((index) => index >= 0);
        const paymentIndexes = matchingIndexes.length
          ? matchingIndexes
          : normalizedInstallments
            .map((item, index) => parseSafe(item.deposited_amount) > 0 ? index : -1)
            .filter((index) => index >= 0);
        const breakdownPayments = Array.isArray(currentDeposit?.payment_breakdown)
          ? currentDeposit.payment_breakdown.reduce(
            (total, item) => total + parseSafe(item.amount),
            0
          )
          : 0;
        const matchingPayments = breakdownPayments > 0
          ? breakdownPayments
          : paymentIndexes.reduce(
            (total, index) => total + parseSafe(normalizedInstallments[index].deposited_amount),
            0
          );
        const receiptLateFee = Math.max(
          parseSafe(studentRecord?.late_fee),
          parseSafe(currentDeposit?.late_fee),
          parseSafe(studentRecord?.amount) - matchingPayments
        );
        const lastIndex = paymentIndexes[paymentIndexes.length - 1];
        if (lastIndex !== undefined && receiptLateFee > 0) {
          normalizedInstallments = normalizedInstallments.map((item, index) =>
            index === lastIndex
              ? { ...item, late_fee: receiptLateFee, late_fee_paid: receiptLateFee }
              : item
          );
        }
      }

      if (insResult.success) {
        setLateFeeConfig({
          frequencySettings,
          lateFeeSettings,
        });
        setReportData((prevState) => ({
          ...prevState,
          payment_date: paymentDateForCalculation,
        }));
      }

      if (studentRecord?.edit) {
        const editableInstallments = normalizedInstallments.map((res) => {
          const isMatched = Array.isArray(res.deposit_id)
            ? res.deposit_id.includes(studentRecord.deposit_id)
            : res.deposit_id === studentRecord.deposit_id;

          if (isMatched) {
            return { ...res, edit: true };
          } else {
            return { ...res, edit: false };
          }
        });
        setBaseInstallments(editableInstallments);
        setStudentInstallment(editableInstallments);
      } else {
        setBaseInstallments(normalizedInstallments);
        setStudentInstallment(normalizedInstallments);
      }
    } catch (error) { }
  }

  const handleCloseModal = () => {
    setFeeDeposit({});
    setdisablebutton(false);
    setTempAmount({});
  };

  const feeDepositHandler = (installments) => {
    const activePaymentDate = reportData?.payment_date
      ? formatDateForPayload(reportData.payment_date)
      : (feeDeposit?.payment_date ? formatDateForPayload(feeDeposit.payment_date) : formatDateForPayload(getCurrentDate()));

    const totals = {
      totalAmount: 0,
      discount: 0,
      previous_due: 0,
      due_amount: 0,
      totalTransportFee: 0,
      grossPayableAmount: 0,
      late_fee: 0,
      netPayableAmount: 0,
      amount: 0,
      payment_date: activePaymentDate,
      payment_method: feeDeposit?.payment_method || "Cash",
      receipt_number: feeDeposit?.receipt_number || "",
      late_joinee_discount: 0,
      deposited_amount: 0,
      historicalDiscount: 0,
      totalAmountWithLateFee: 0,
      installments: [],
      deposit_id: null,
      isPartialPayment: false,
    };

    const hasOthersDiscount = installments?.some((res) =>
      res.discounts?.some((d) => d.name === "Others" || d.name === "Other")
    );
    setIsDiscountEditable(hasOthersDiscount);

    const parseAmount = parseSafe;
    const isAnyPartialPayment = installments?.some((res) =>
      res.status === "partial" ||
      (res.status === "pending" && parseAmount(res.deposited_amount) > 0)
    );

    totals.isPartialPayment = isAnyPartialPayment;

    installments?.forEach((res) => {
      const transportFee = parseAmount(res?.transport_fee);
      const installmentAmt = parseAmount(res?.installment_amount);
      const installmentDiscount = parseAmount(res?.installment_discount);
      const previousDue = parseAmount(res?.previous_due);
      const lateFee = res?.late_fee ? res?.late_fee : 0;
      const depositedAmt = parseAmount(res?.deposited_amount || 0);

      const instOriginalBase = installmentAmt + transportFee + previousDue - installmentDiscount;
      const remainingBaseDue = Math.max(0, instOriginalBase - depositedAmt);

      const isItemPartial =
        res.status === "partial" ||
        (res.status === "pending" && depositedAmt > 0);

      const totalLateFeeLiability = parseSafe(res.pushed_late_fee || 0) > 0
        ? parseSafe(res.pushed_late_fee || 0)
        : parseSafe(res.late_fee || 0);
      const remainingLateFee = Math.max(0, totalLateFeeLiability - parseSafe(res.late_fee_paid || 0));

      const itemGross = isItemPartial
        ? remainingBaseDue
        : (installmentAmt + transportFee);
      const itemNet = isItemPartial
        ? remainingBaseDue + remainingLateFee
        : (installmentAmt + transportFee + previousDue + totalLateFeeLiability - installmentDiscount);

      totals.installments.push({
        id: res?.id,
        installment_discount: installmentDiscount,
        late_fee: lateFee,
        pushed_late_fee: res?.pushed_late_fee,
        late_fee_paid: res?.late_fee_paid,
        deposited_amount: res?.deposited_amount,
        month: res?.month,
        transport_fee: res?.transport_fee,
        transport_fee_paid: res?.transport_fee_paid
      });
      totals.late_joinee_discount = parseAmount(res?.late_joinee_discount);
      totals.totalAmount += itemGross;
      totals.historicalDiscount += isItemPartial ? 0 : installmentDiscount;
      totals.previous_due += isItemPartial ? 0 : previousDue;
      totals.totalTransportFee += transportFee;
      totals.grossPayableAmount += isItemPartial ? remainingBaseDue : (installmentAmt + transportFee - installmentDiscount);
      totals.netPayableAmount += itemNet;
      totals.late_fee += isItemPartial ? remainingLateFee : totalLateFeeLiability;
      totals.deposited_amount += isItemPartial ? 0 : depositedAmt;
    });

    const displayedDiscount = totals.historicalDiscount;
    const historicalDiscountForCalculation = totals.historicalDiscount;
    const currentDiscount = 0;

    const netPayable = totals.netPayableAmount;
    const amountPaid = netPayable;
    let dueAmt = 0;

    const finalTotals = {
      ...feeDeposit,
      ...totals,
      discount: displayedDiscount,
      currentDiscount: currentDiscount,
      historicalDiscount: historicalDiscountForCalculation,
      totalAmountWithLateFee: totals.totalAmount + totals.late_fee,
      netPayableAmount: netPayable,
      due_amount: Math.round(dueAmt),
      amount: amountPaid,
      previous_due: studentRecord?.previous_due || totals.previous_due || 0,
      grossPayableAmount: totals.grossPayableAmount,
    };

    setFeeDeposit(finalTotals);
    setTempAmount(finalTotals);
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.name === "amount") {
      if (isNaN(e.target.value)) {
        return;
      }

      const enteredValue = e.target.value;
      const netPayable = parseSafe(feeDeposit?.netPayableAmount || 0);

      if (enteredValue !== "" && parseFloat(enteredValue) <= netPayable) {
        const val = parseFloat(enteredValue);
        const dueAmount = Math.max(0, netPayable - val);

        setFeeDeposit({
          ...feeDeposit,
          [e.target.name]: enteredValue,
          due_amount: Math.round(dueAmount),
        });
      } else if (enteredValue === "") {
        setFeeDeposit({
          ...feeDeposit,
          [e.target.name]: "0",
          due_amount: netPayable,
        });
      } else {
        toast.error("Entered amount exceeds net payable amount!");
      }
    } else if (e.target.name === "late_fee") {
      if (e.target.value > 100000000) {
        return toast.error("Enter valid late fee");
      }

      const late = parseInt(e.target.value) || 0;
      const baseGross = parseSafe(feeDeposit?.totalAmount || 0);
      const prevDue = parseSafe(feeDeposit?.previous_due || 0);
      const currentDisc = parseSafe(feeDeposit?.discount || 0);

      const newGross = Math.max(0, baseGross - currentDisc);
      const newNet = newGross + prevDue + late;

      setFeeDeposit({
        ...feeDeposit,
        late_fee: late,
        grossPayableAmount: newGross,
        totalAmountWithLateFee: parseSafe(feeDeposit?.totalAmount) + late,
        netPayableAmount: newNet,
        amount: newNet,
        due_amount: 0,
      });
    } else if (e.target.name === "payment_method") {
      if (e.target.value !== "Cash") {
        setShowTransaction(false);
      } else {
        setShowTransaction(true);
      }
      setFeeDeposit({ ...feeDeposit, [e.target.name]: e.target.value });
    } else if (e.target.name === "receipt_number") {
      const numericValue = e.target.value.replace(/\D/g, "");
      setFeeDeposit({ ...feeDeposit, [e.target.name]: numericValue });
    } else if (e.target.name === "discount") {
      const disc = parseInt(e.target.value) || 0;
      const baseTotal = parseSafe(feeDeposit?.totalAmount || 0);
      const lateFee = parseSafe(feeDeposit?.late_fee || 0);
      const prevDue = parseSafe(feeDeposit?.previous_due || 0);
      const historicalDiscount = parseSafe(feeDeposit?.historicalDiscount || 0);

      const newCurrentDiscount = Math.max(0, disc - historicalDiscount);
      const newGross = Math.max(0, baseTotal - disc);
      const newNet = newGross + prevDue + lateFee;

      const newAmount = newNet;

      setFeeDeposit({
        ...feeDeposit,
        discount: disc,
        currentDiscount: newCurrentDiscount,
        grossPayableAmount: newGross,
        netPayableAmount: newNet,
        amount: newAmount,
        due_amount: 0,
      });
    } else {
      setFeeDeposit({ ...feeDeposit, [e.target.name]: e.target.value });
    }
  };

  const amountManager = () => {
    if (feeDeposit.amount <= 0) {
      feeDeposit.amount = feeDeposit.netPayableAmount;
    }
  };

  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
    documentTitle: "FeeReceipt",
    onAfterPrint: () => {
      setIsReceiptReady(false);
      setSelectedReceiptData(null);
      if (studentRecord.edit) {
        navigate("/feedepositehistory/e", {
          state: { row: { student_info: location.state.row } },
        });
      } else {
        navigate(0);
      }
    },
  });

  const saveAsPdf = async (data) => {
    const element = receiptRef.current;
    const options = {
      margin: 0,
      filename: "FeeReceipt.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    };

    const pdfBlob = await html2pdf()
      .set(options)
      .from(element)
      .toPdf()
      .output("blob");
    const formData = new FormData();
    formData.append("file", pdfBlob, "FeeReceipt.pdf");

    const result = await schoolApi.createFile(data.deposit_id, formData);
  };

  const handlePrintClick = async (data) => {
    try {
      setIsReceiptReady(false);
      setSelectedReceiptData(data);
    } catch (error) { }
  };

  useEffect(() => {
    if (selectedReceiptData && isReceiptReady) {
      handlePrint();
    }
  }, [selectedReceiptData, isReceiptReady, handlePrint]);

  async function payonline() {
    const amount = feeDeposit?.amount
      ? feeDeposit?.amount
      : feeDeposit?.netPayableAmount
        ? feeDeposit?.netPayableAmount
        : 0;
    try {
      if (amount > 0) {
        const res = await loadScript(
          "https://checkout.razorpay.com/v1/checkout.js"
        );
        if (!res) {
          alert("Razorpay failed to load!!");
          return;
        }

        const data = await schoolApi.FeeDepositOnline(amount);

        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY || "rzp_test_TTXMLV0ERseASl", // Use environment variable or fallback to test key
          amount: amount * 100,
          currency: "INR",
          name: "Acme Corp",
          description: "Test Transaction",
          image: "https://example.com/your_logo",
          order_id: data.result.id,
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#3399cc",
          },
          handler: async function (response) {
            try {
              const paymentData = {
                order_id: response.order_id,
                payment_id: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                student_addmission_id: studentRecord?.student_addmission_id,
                amount: amount,
                payment_date: new Date(),
                payment_method: "Online (Razorpay)",
                transaction_no: response.razorpay_payment_id,
                status: "Success",
              };
              if (response.razorpay_payment_id) {
                feeDeposit.payment_method = "razorpay";
                feeDeposit.transaction_no = response.razorpay_payment_id;
                handleSaveDeposites();
              } else {
                toast.error("payment not acctepable");
              }
            } catch (error) {
              toast.error("Something went wrong while saving payment.");
            }
          },
          prefill: {
            name: feeDeposit?.student_name,
            email: feeDeposit?.student_email,
            contact: feeDeposit?.student_contact,
          },
          modal: {
            ondismiss: function () { },
          },
        };

        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      } else {
        toast.error("Enter amount gerterthan zero");
      }
    } catch (error) { }
  }

  const handleSaveDeposites = async () => {
    try {
      const chosenPaymentDate = formatDateForPayload(
        reportData?.payment_date || feeDeposit?.payment_date || getCurrentDate()
      );

      if (
        feeDeposit.amount === null ||
        feeDeposit.amount === undefined ||
        feeDeposit.amount === "" ||
        !chosenPaymentDate ||
        !feeDeposit.payment_method
      ) {
        return toast.error("Missing requirwed fields!!");
      }

      if (receiptNumberMode === "manual" && (!feeDeposit?.receipt_number || feeDeposit.receipt_number.trim() === "")) {
        return toast.error("Receipt number is required in Manual mode");
      }


      let finalAmount = parseFloat(feeDeposit.amount);
      if (isNaN(finalAmount) || finalAmount <= 0) {
        return toast.error("Please enter an amount greater than 0");
      }

      const finalDue = Math.max(
        0,
        Math.round(feeDeposit.netPayableAmount - finalAmount)
      );

      feeDeposit.amount = finalAmount;
      feeDeposit.due_amount = finalDue;

      // if (feeDeposit.payment_method !== "Cash" && !feeDeposit?.transaction_no) {
      //   return toast.error("Missing required fields!!");
      // }
      if (feeDeposit.amount > feeDeposit.netPayableAmount) {
        return toast.error("Amount is greater then net payable amount");
      }


      // Distribute the manual late fee total across installments to avoid ghost balance
      const totalManualLateFee = parseSafe(feeDeposit?.late_fee || 0);
      const updatedInstallments = [...(feeDeposit?.installments || [])];

      if (updatedInstallments.length > 0) {
        // Calculate the sum of REMAINING late fees currently in the installments list (Charged - Already Paid)
        const currentRemainingSum = updatedInstallments.reduce((acc, inst) => {
          const liability = parseSafe(inst.pushed_late_fee || inst.late_fee || 0);
          const alreadyPaid = parseSafe(inst.late_fee_paid || 0);
          return acc + Math.max(0, liability - alreadyPaid);
        }, 0);

        // If user manually changed the total late fee in the footer
        if (totalManualLateFee !== currentRemainingSum) {
          const diff = totalManualLateFee - currentRemainingSum;
          const lastIdx = updatedInstallments.length - 1;

          // Adjust the last installment's total liability by the difference
          const lastInstTotalLiability = parseSafe(updatedInstallments[lastIdx].pushed_late_fee || updatedInstallments[lastIdx].late_fee || 0);
          updatedInstallments[lastIdx].pushed_late_fee = Math.max(0, lastInstTotalLiability + diff);
        }

        // Accurately distribute the total discount to fresh or partial installments
        const freshInstallments = updatedInstallments.filter((inst) => {
          const fullInst = (studentInstallment || []).find((i) => i.id === inst.id);
          const depAmt = parseSafe(fullInst?.deposited_amount || 0);
          return !(fullInst?.status === "partial" || (fullInst?.status === "pending" && depAmt > 0));
        });

        const partialInstallments = updatedInstallments.filter((inst) => {
          const fullInst = (studentInstallment || []).find((i) => i.id === inst.id);
          const depAmt = parseSafe(fullInst?.deposited_amount || 0);
          return fullInst?.status === "partial" || (fullInst?.status === "pending" && depAmt > 0);
        });

        const userTotalDiscount = parseSafe(feeDeposit?.discount || 0);

        if (freshInstallments.length > 0) {
          const sharePerFresh = Math.round(userTotalDiscount / freshInstallments.length);
          updatedInstallments.forEach((inst) => {
            const isFresh = freshInstallments.some((f) => f.id === inst.id);
            if (isFresh) {
              inst.installment_discount = sharePerFresh;
            }
          });
        } else if (partialInstallments.length > 0 && userTotalDiscount > 0) {
          // When paying only partial installments and user enters an additional discount,
          // allocate up to each installment's actual remaining balance, leaving the rest for subsequent installments
          let remainingUserDiscount = userTotalDiscount;
          partialInstallments.forEach((inst, idx) => {
            const fullInst = (studentInstallment || []).find((i) => i.id === inst.id);
            const existingDisc = parseSafe(fullInst?.installment_discount || inst.installment_discount || 0);
            const baseAmount = parseSafe(fullInst?.installment_amount || inst.installment_amount || 0) +
                               parseSafe(fullInst?.transport_fee || inst.transport_fee || 0);
            const depAmt = parseSafe(fullInst?.deposited_amount || 0);
            const remainingBalance = Math.max(0, baseAmount - existingDisc - depAmt);

            const isLast = idx === partialInstallments.length - 1;
            const allocatedAdditional = isLast
              ? remainingUserDiscount
              : Math.min(remainingBalance, remainingUserDiscount);

            remainingUserDiscount = Math.max(0, remainingUserDiscount - allocatedAdditional);
            inst.installment_discount = existingDisc + allocatedAdditional;
          });
        }
      }

      const arr = {
        totalAmount: feeDeposit?.totalAmount,
        netPayableAmount: feeDeposit?.netPayableAmount,
        student_addmission_id: studentRecord?.student_addmission_id,
        student_id: studentRecord.student_id || studentRecord.id,
        discount: parseSafe(feeDeposit?.discount || 0),
        installments: updatedInstallments, // Use the synced installments
        amount: feeDeposit?.amount
          ? feeDeposit?.amount
          : feeDeposit.netPayableAmount, // updated
        late_joinee_discount: feeDeposit?.late_joinee_discount,
        sessionid: studentRecord?.session_id,
        payment_date: chosenPaymentDate,
        payment_method: feeDeposit?.payment_method,
        receipt_number: feeDeposit?.receipt_number,
        late_fee: totalManualLateFee,
        remark: feeDeposit?.remark,
        due_amount: feeDeposit?.due_amount,
        transaction_no: feeDeposit?.transaction_no,
        isManualDiscount: parseSafe(feeDeposit?.discount || 0) > 0,
      };


      if (studentRecord.edit) {
        setdisablebutton(true);
        const feeDepositEditResult = await schoolApi.updateFeeDepositsById(
          studentRecord?.deposit_id,
          arr
        );

        if (feeDepositEditResult) {
          arr.deposit_id = feeDepositEditResult.result.newFeeDeposite.id;

          toast.success("Fees deposite Updated successfully!!");
          await handlePrintClick(arr);
        } else {
        }
      } else {
        setdisablebutton(true);
        if (arr) {
          const feeDepositResult = await schoolApi.createFeeDeposit(arr);

          if (feeDepositResult) {
            arr.deposit_id = feeDepositResult.deposit.id;
            toast.success("Fees deposited successfully!!");
            await handlePrintClick(arr);
          } else {
            setdisablebutton(false);
            toast.error("Fee deposit could not be saved");
          }
        }
      }
    } catch (error) {
      setdisablebutton(false);
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Fee deposit could not be saved"
      );
    }
  };
  const formatNumberWithCommas = (number) => {
    return number ? number.toLocaleString("en-IN") : "0";
  };
  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      <Row className="g-0">
        <Col lg={2} className="mx-3">
          <Link className="nav-link mx-2" to="/">
            Home <i className="fa-solid fa-chevron-right"></i> Fee Deposit Create
          </Link>
        </Col>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <Row className="view-form">
          <Row className="section-header mx-2">
            <Col lg={9}>
              <span>Fee Deposit Edit</span>
            </Col>
            <Col lg={3} className="d-flex justify-content-end">
              <Button className="btn-sm mx-2" onClick={() => navigate(-1)}>
                Back
              </Button>
            </Col>
          </Row>
          <Row
            className="mx-3"
            style={{ backgroundColor: "white", borderRadius: "10px" }}
          >
            <Row className="pb-3">
              <Col lg={1}></Col>
              <Col lg={5}>
                <label>Student Name</label>
                <span>{studentRecord?.studentname}</span>
              </Col>
              <Col lg={5}>
                <label>Email</label>
                <span>{studentRecord?.email}</span>
              </Col>
              <Col lg={1}></Col>
              <Col lg={1}></Col>
              <Col lg={5}>
                <label>Dob</label>
                <span>
                  {moment(studentRecord.dateofbirth).format("DD-MM-YYYY")}
                </span>
              </Col>
              <Col lg={5}>
                <label>Category</label>
                <span>{studentRecord?.category}</span>
              </Col>

              <Col lg={1}></Col>
              <Col lg={1}></Col>
              <Col lg={5}>
                <label>Phone</label>
                <span>{studentRecord?.phone}</span>
              </Col>
              <Col lg={5}>
                <label>Total Fees (₹)</label>
                 {/* {formatNumberWithCommas(parseInt(studentRecord?.total_fees))} */}
                <span>
                  {formatNumberWithCommas(
                    feeDeposit?.netPayableAmount ?? parseInt(studentRecord?.total_fees)
                  )}
                </span>
              </Col>

              <Col lg={1}></Col>
              <Col lg={1}></Col>
              <Col lg={1}></Col>

              <Col></Col>
            </Row>
          </Row>
          <Col lg={2}></Col>
        </Row>

        {studentInstallment && (
          <InstallmentTable
            data={studentInstallment}
            edit={studentRecord?.edit}
            feeDepositHandler={feeDepositHandler}
            feeDeposit={feeDeposit}
            studentRecord={studentRecord}
          />
        )}

        {feeDeposit?.totalAmount > 0 && (
          <>
            <Row>
              <Col lg={1}></Col>
              <Col lg={5} className="mb-3">
                <Row>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Total Amount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="totalAmount"
                      placeholder="Enter Duration"
                      //  value={feeDeposit?.totalAmountWithLateFee ?? feeDeposit?.totalAmount}
                      value={feeDeposit?.netPayableAmount ?? feeDeposit?.totalAmount}
                      onChange={(e) => handleChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Row>
                {feeDeposit?.late_joinee_discount > 0 && (
                  <Row>
                    <Form.Group className="mt-3 mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicFirstName"
                      >
                        Late Joinee Discount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={feeDeposit?.late_joinee_discount}
                        name="late_joinee_discount"
                        placeholder="0"
                        onChange={(e) => handleChange(e)}
                      />
                    </Form.Group>
                  </Row>
                )}

                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicReceiptNumber"
                    >
                      Receipt Number {receiptNumberMode === "manual" ? <span className="text-danger">*</span> : "(Auto / Optional)"}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      required={receiptNumberMode === "manual"}
                      value={feeDeposit?.receipt_number || ""}
                      name="receipt_number"
                      placeholder={receiptNumberMode === "manual" ? "Enter Receipt Number (Required)" : "Auto Generated / Enter custom"}
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Discount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      disabled={!isDiscountEditable}
                      value={feeDeposit?.discount}
                      name="discount"
                      placeholder="Enter Discount"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Gross Payable
                    </Form.Label>
                    <Form.Control
                      type="number"
                      disabled
                      value={feeDeposit?.grossPayableAmount}
                      name="gross_payable"
                      placeholder="Enter Discount"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className=" mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Prevoius Dues
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="previous_due"
                      placeholder="Total Dues"
                      value={feeDeposit?.previous_due}
                      onChange={(e) => handleChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Row>

                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Late Fee
                    </Form.Label>
                    <Form.Control
                      type="number"
                      value={feeDeposit?.late_fee}
                      name="late_fee"
                      placeholder="Enter Late Fee"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicEmail"
                    >
                      Net Payable Amount
                    </Form.Label>
                    <Form.Control
                      type="number"
                      name="net_payable_amount"
                      placeholder="Net Payable Amount"
                      value={feeDeposit?.netPayableAmount}
                      onChange={(e) => handleChange(e)}
                      disabled
                    />
                  </Form.Group>
                </Row>
              </Col>
              <Col lg={5}>
                <Row>
                  <Form.Group className=" mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Enter Amount
                    </Form.Label>
                    <Form.Control
                      required
                      type="numeric"
                      inputMode="numeric"
                      value={
                        feeDeposit?.amount
                          ? feeDeposit?.amount
                          : feeDeposit?.netPayableAmount
                            ? feeDeposit?.netPayableAmount
                            : 0
                      }
                      name="amount"
                      placeholder="Enter Deposite Amount"
                      onChange={(e) => handleChange(e)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Due Amount
                    </Form.Label>
                    <Form.Control
                      disabled
                      type="number"
                      value={feeDeposit?.due_amount}
                      name="due_amount"
                      placeholder="Enter Due Amount"
                      onChange={(e) => handleChange(e, null, null)}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicLastName"
                    >
                      Deposite Date
                    </Form.Label>
                    <DatePicker
                      required
                      selected={reportData.payment_date}
                      onChange={(date) =>
                        handleDateChange(date, "payment_date")
                      }
                      dateFormat="dd-MM-yyyy"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      placeholderText="Select a date"
                      className="form-control"
                      style={{ width: "300px" }}
                      onKeyDown={(e) => e.preventDefault()}
                      highlightDates={[new Date()]}
                    />
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicClass"
                    >
                      Payment Method
                    </Form.Label>
                    <Form.Select
                      required
                      name="payment_method"
                      value={feeDeposit?.payment_method}
                      onChange={(e) => handleChange(e)}
                    >
                      <option value="" disabled>
                        -- Select Type --
                      </option>
                      <option value="Cash">Cash</option>
                      <option value="NEFT">NEFT</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Paytm">Paytm</option>
                    </Form.Select>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group className="mt-3 mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Transaction Number
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={feeDeposit?.transaction_no}
                      name="transaction_no"
                      placeholder="Enter Transaction No"
                      // required={
                      //   feeDeposit?.payment_method &&
                      //   feeDeposit?.payment_method !== "Cash"
                      // }
                      onChange={(e) => handleChange(e)}
                      disabled={showTransaction && !feeDeposit?.transaction_no}
                    />
                  </Form.Group>
                </Row>
                <Row className="mt-3 ms-2">
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicFirstName"
                    >
                      Remark
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      value={feeDeposit?.remark}
                      name="remark"
                      placeholder="Enter Remark"
                      onChange={(e) => handleChange(e, null, null)}
                    />
                  </Form.Group>
                </Row>
              </Col>
              <Col lg={1}></Col>
            </Row>
            <Row className={"justify-content-center"}>
              <Col lg={3}>
                <Button
                  className="mx-3 mt-3 mb-3"
                  variant="secondary"
                  onClick={handleCloseModal}
                  disabled={disablebutton}
                >
                  Close
                </Button>
                <Button
                  className="mx-3 mt-3 mb-3"
                  variant="primary"
                  onClick={handleSaveDeposites}
                  disabled={disablebutton}
                >
                  Save
                </Button>

                <Button
                  className="mx-3 mt-3 mb-3"
                  backgroundColor="#e8ad2e"

                  onClick={payonline}
                  disabled={disablebutton}
                >
                  Pay Online
                </Button>
              </Col>
            </Row>
            {selectedReceiptData && (
              <div style={{ display: "none" }}>
                <FeeReceipt
                  ref={receiptRef}
                  receiptData={selectedReceiptData}
                  onReady={() => setIsReceiptReady(true)}
                />
              </div>
            )}
          </>
        )}
      </Row>
    </>
  );
};

export default FeeDepositeEdit;
